import { DisDocuments } from '@xbcb/document-types';

export default DisDocuments.SUPPORTED_DOCUMENTS.reduce((acc, disDocument) => {
  return { ...acc, [disDocument.labelCode]: disDocument.name };
}, {});
